<script>
import { GlButton } from '@gitlab/ui';
import vulnerabilitiesCreateIssue from 'ee/security_dashboard/graphql/mutations/vulnerabilities_create_issue.mutation.graphql';
import { convertToGraphQLId } from '~/graphql_shared/utils';
import { TYPENAME_PROJECT } from '~/graphql_shared/constants';
import { visitUrl } from '~/lib/utils/url_utility';
import * as Sentry from '~/sentry/sentry_browser_wrapper';
import SelectProjectDropdown from './select_project_dropdown.vue';

export default {
  components: {
    GlButton,
    SelectProjectDropdown,
  },
  inject: {
    vulnerabilitiesQuery: {
      required: true,
    },
    vulnerabilitiesCountsQuery: {
      required: false,
      default: null,
    },
    projectId: {
      required: false,
      default: null,
    },
  },
  props: {
    selectedVulnerabilities: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isSubmitting: false,
      selectedProjectId: null,
      projectValid: true,
    };
  },
  computed: {
    vulnerabilityIds() {
      return this.selectedVulnerabilities.map((vuln) => vuln.id);
    },
    showProjectDropdown() {
      return !this.projectId;
    },
  },
  methods: {
    async handleSubmit() {
      this.$emit('clear-rejected');

      const resolvedProjectId = this.projectId || this.selectedProjectId;
      this.projectValid = Boolean(resolvedProjectId);

      if (!this.projectValid) return;

      this.isSubmitting = true;

      try {
        const { data } = await this.$apollo.mutate({
          mutation: vulnerabilitiesCreateIssue,
          variables: {
            vulnerabilityIds: this.vulnerabilityIds,
            project: convertToGraphQLId(TYPENAME_PROJECT, resolvedProjectId),
          },
          refetchQueries: [this.vulnerabilitiesQuery, this.vulnerabilitiesCountsQuery],
          awaitRefetchQueries: true,
        });

        if (data.vulnerabilitiesCreateIssue.errors) {
          throw data.vulnerabilitiesCreateIssue.errors;
        }

        this.$emit('vulnerabilities-updated', this.vulnerabilityIds);
        visitUrl(data.vulnerabilitiesCreateIssue?.issue?.webUrl);
      } catch (error) {
        Sentry.captureException(error);
        this.$emit('update-rejected', this.selectedVulnerabilities);
      }

      this.isSubmitting = false;
    },
  },
};
</script>

<template>
  <form
    class="gl-flex gl-flex-grow gl-flex-wrap gl-items-start gl-gap-3"
    @submit.prevent="handleSubmit"
  >
    <select-project-dropdown
      v-if="showProjectDropdown"
      v-model="selectedProjectId"
      :valid="projectValid"
      @input="projectValid = true"
    />
    <gl-button
      class="gl-ml-auto"
      :disabled="isSubmitting"
      data-testid="cancel-add-new-button"
      @click="$emit('cancel')"
    >
      {{ __('Cancel') }}
    </gl-button>
    <gl-button
      data-testid="add-new-button"
      type="submit"
      variant="confirm"
      :loading="isSubmitting"
      class="js-no-auto-disable"
    >
      {{ s__('SecurityReports|Create issue') }}
    </gl-button>
  </form>
</template>
